export default __webpack_public_path__ + "static/media/ASR_MONTAJ_SATIS_BOLGELERI.f86bc189.xlsx";